import { logger } from '@damofire/data-commons';
import { Remote, wrap } from 'comlink';
import { Observer, Subject } from 'rxjs';
import { WarehouseSyncStepContextEvent, WarehouseSyncStepTask, WarehouseSyncStepTaskContext } from '../executors';
import { WarehouseOutlinesStepsWorker } from '../workers/outlines.steps.worker';
import { executeWorker, WarehouseSyncStepWorkerFactory } from './steps-utils';

class WarehouseOutlinesSyncWorkerFactory implements WarehouseSyncStepWorkerFactory<WarehouseOutlinesStepsWorker> {
  async createWorker(environment: any): Promise<[Worker, WarehouseOutlinesStepsWorker | Remote<WarehouseOutlinesStepsWorker>]> {
    if (environment.appConfig.watson.useWebworkers) {
      const warehouseWorker = new Worker(new URL('../workers/outlines.steps.worker', import.meta.url), { type: 'module' });
      const warehouseWorkerProxy = wrap<typeof WarehouseOutlinesStepsWorker>(warehouseWorker);
      const workerService = await new warehouseWorkerProxy();
      return [warehouseWorker, workerService];
    }

    return [null, new WarehouseOutlinesStepsWorker()];
  }
}

export class WarehouseDownloadOutlinesSyncStepTask implements WarehouseSyncStepTask {
  constructor(private readonly environment: any) {}

  name(): string {
    return `DOWN_OUT_TASK`;
  }

  async execute(ctx: WarehouseSyncStepTaskContext, listener: Observer<WarehouseSyncStepContextEvent>, taskBreaker: Subject<boolean>): Promise<void> {
    logger.debug('Executing download outlines sync task.');
    await executeWorker(ctx, this.environment, listener, new WarehouseOutlinesSyncWorkerFactory(), taskBreaker);
  }
}

export class WarehouseCleanOutlinesSyncStepTask implements WarehouseSyncStepTask {
  constructor(private readonly environment: any) {}

  name(): string {
    return `CLEAN_OUT_TASK`;
  }

  async execute(ctx: WarehouseSyncStepTaskContext, listener: Observer<WarehouseSyncStepContextEvent>, taskBreaker: Subject<boolean>): Promise<void> {
    logger.debug('Executing clean outlines sync task.');
    await executeWorker(ctx, this.environment, listener, new WarehouseOutlinesSyncWorkerFactory(), taskBreaker);
  }
}

export class WarehousePushOutlinesSyncStepTask implements WarehouseSyncStepTask {
  constructor(private readonly environment: any) {}

  name(): string {
    return `PUSH_OUT_TASK`;
  }

  async execute(ctx: WarehouseSyncStepTaskContext, listener: Observer<WarehouseSyncStepContextEvent>, taskBreaker: Subject<boolean>): Promise<void> {
    logger.debug('Executing push outlines sync task.');
    await executeWorker(ctx, this.environment, listener, new WarehouseOutlinesSyncWorkerFactory(), taskBreaker);
  }
}
